export { default } from './delete-modal-select';
